'use client';

import { ChakraProvider, type SystemContext } from '@chakra-ui/react';
import { ColorModeProvider, type ColorModeProviderProps } from './color-mode';
import Fonts from './fonts';

type ProviderProps = Omit<ColorModeProviderProps, 'value'> & {
    value: SystemContext;
};

export function Provider({ value, ...props }: ProviderProps) {
    return (
        <ChakraProvider value={value}>
            <Fonts />
            <ColorModeProvider {...props} />
        </ChakraProvider>
    );
}
